import api from 'api/axiosInstance';
import { stringify } from 'query-string';
import type { BoundingBoxOCR } from 'types/ai.types';
import type { IExpenseCategory, VATPeriod } from 'types/expenses.types';
import type {
  DocumentSubmission,
  LockStatusType,
  LockStatusTypeCatgoriesed,
} from 'types/global.types';
import { VATTypeEnum } from 'types/users.types';
import { BEVehicle, DEVehicle } from 'types/vehicle.types';
import { formatLockStatus } from 'utils/helpers';

const service = '/v2/expenses';

type IAPIBulkUpdateExpensesBody = {
  resourceId: string;
  body: { reviewed: boolean };
}[];

type IAPIBulkUpdateExpensesResponse = {
  _id: string;
  ok: boolean;
  status: string;
  errors?: { message: string; code: string }[];
  type?: string;
}[];

// TODO: return expense type

// TODO: return expense type

// TODO: return expense type
export const bulkUpdateExpenses = (
  ops: IAPIBulkUpdateExpensesBody,
): Promise<IAPIBulkUpdateExpensesResponse> =>
  api.patch(`${service}/bulk`, { ops });

export const bulkDeleteExpenses = (
  ids: string[],
): Promise<IAPIBulkUpdateExpensesResponse> =>
  api.delete(`${service}/bulk?${stringify({ ids }, { arrayFormat: 'comma' })}`);

export const bulkValidateExpenses = (
  ids: string[],
): Promise<IAPIBulkUpdateExpensesResponse> => {
  return api.patch(`${service}/bulk`, {
    ops: ids.map((id) => ({
      resourceId: id,
      body: {
        reviewed: true,
      },
    })),
  });
};

// TODO: type

export const getExpenseSubmissionHistory = (
  id: string,
): Promise<DocumentSubmission[]> => {
  return api.get(`${service}/${id}/tax-submissions`);
};

// TODO: type
// export const getExpenseTaxImpact = (expenseId: string): Promise<void> =>
//   api.get(`${service}/${expenseId}/tax-impact`);

type LockStatusBody = Partial<{
  expenseDate: string;
  user: Partial<{
    VATType: string;
    VATReturnFrequency: string;
  }>;
  period: VATPeriod;
}>;
type LockStatusResponse = { taxLock: LockStatusType };

export const getLockStatus = (
  body: LockStatusBody,
): Promise<LockStatusTypeCatgoriesed> => {
  if (
    !body.expenseDate ||
    !body.user?.VATType ||
    !body.user?.VATReturnFrequency
  ) {
    return Promise.resolve(null);
  }
  if (body.user?.VATType === VATTypeEnum.subjectToVAT && !body.period) {
    return Promise.resolve(null);
  }
  return api
    .post<any, LockStatusResponse>(`${service}/tax-lock`, body, {
      ignoreToast: true,
    })
    .then((data) => formatLockStatus(data.taxLock))
    .catch(() => null);
};

export const getWorkingDaysAndDeductibleAmount = (
  year: number,
  expenseId?: string | null,
) =>
  api
    .get<any, { days?: number; amount?: number } | undefined>(
      `${service}/drive-to-work/working-days/${year}${
        expenseId ? `?expenseId=${expenseId}` : ''
      }`,
    )
    .then((data) => ({ days: data?.days || 0, amount: data?.amount || 0 }))
    .catch(() => ({ days: 0, amount: 0 }));

export type GetExpenseCategoriesGuessedParams = {
  filename?: string | null;
  supplierName?: string;
  transactions?: string[];
};

export type GetExpenseCategoriesGuessedResponse = {
  category: IExpenseCategory;
  vehicle?: BEVehicle | DEVehicle;
  guessedCategoryFrom: string;
};

export const getExpenseCategoriesGuessed = (
  params: GetExpenseCategoriesGuessedParams,
): Promise<GetExpenseCategoriesGuessedResponse[]> =>
  api.get(`${service}/guess/categories`, { params });

export const getBoundingBoxes = (
  expenseId: string,
): Promise<{
  entities: BoundingBoxOCR[];
}> => api.get(`${service}/${expenseId}/ocr/bounding-boxes`);
